import React from "react";
import gql from "graphql-tag";
import SaveForLater from "./save-for-later";
import { Mutation } from "react-apollo";

export const triggerSignupDefault = {
    triggerSignup: {
        __typename: "TriggerSignup",
        clickCount: 0
    }
};

export const triggerSignupMutation = {
    triggerSignup: (_, __, { cache }) => {
        const query = gql`
            query triggerSignup @client {
                clickCount
            }
        `;

        const { triggerSignup } = cache.readQuery({ query });
        const { clickCount } = triggerSignup;
        const incrementClickCount = clickCount + 1;
        const data = {
            triggerSignup: {
                __typename: "TriggerSignup",
                clickCount: incrementClickCount
            }
        };
        cache.writeData({ data });
        return null;
    }
};

const TRIGGER_SIGNUP = gql`
    mutation triggerSignup($unused: Int!) {
        triggerSignup(unused: $unused) @client
    }
`;

function TriggerSignUpSFLB() {
    return (
        <Mutation mutation={TRIGGER_SIGNUP}>
            {triggerSignup => <SaveForLater onClick={triggerSignup} isSaved={false} />}
        </Mutation>
    );
}

export default TriggerSignUpSFLB;
